import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPolicyCompliance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm15 10.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0m-2.933-1.868a.617.617 0 0 1 0 .873l-3.41 3.41-1.711-1.613a.617.617 0 1 1 .846-.898l.84.79 2.562-2.562a.617.617 0 0 1 .873 0M6.498 15a6.5 6.5 0 0 1-.48-3H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1zM3 7h6.034a6.52 6.52 0 0 0-2.536 3H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPolicyCompliance;
